import { createCachedFunction as cacher } from 'services/utils'

export const entitySetter = (state, entities, isHardReset) => {
  const s = {...state};

  if (!Array.isArray(entities)) {
    entities = [entities];
  }

  entities.forEach( entity => {

    s[entity.id] = {
      ...( isHardReset ? {} : s[entity.id] ),
      ...entity,
    }
  });

  return s;
}

export const createCachedFunction = cacher
